import { z } from 'zod';
import { rolesSchema } from './role.schema';

const userStateSchema = z.enum(['Enabled', 'Disabled', 'Suspended', 'Expired']);

export const authAccountSchema = z.object({
  accountId: z.number().min(1),
  userId: z.number().min(1),
  userName: z.string().nullable(),
  userState: userStateSchema,
  accountName: z.string().min(1),
  accountAlias: z.string(),
  expirationDate: z.string().nullable(),
  roleName: rolesSchema.nullable(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
});

export type AuthAccount = z.infer<typeof authAccountSchema>;
